<div class="ring" *ngIf="loading">
  Loading.
  <span class="span"></span>
</div>

<ng-container>
  <div class="px-3 py-5 main-content-page">
    <div class="fw-light fs-1 col-xl-12">
      <!-- <div class="back-link">
        <img  alt="back-link"src="../../../assets/img/right-icon.png" />
        <a href="#" (click)="goBack($event)">Back to [origin/close window]</a>
      </div> -->
      <h4 class="head-title">{{ "home_title" | translate }}</h4>
    </div>
 
    <div class="row card-group py-2 pt-0 main-page">
      <div
        class="col- col-sm-12 col-md-6 col-lg-6 col-xl-6 px-2 py-2"
        *ngFor="let card of cardData"
      >
        <app-card [card]="card" *ngIf="card.isShow"></app-card>
      </div>
    </div>
    <div class="row py-2 id-help text-center mx-3" *ngIf="ismyredirecttoHomeEnabled">
    
      <div class="footer-card-titile mt-3">{{ 'mnumyidhelp' | translate }}</div>
        <div class="footer-subtext">{{ 'msghelp' | translate }}</div>
        <div class="py-2">
          <button type="button" class="btn btn-home-edit py-2 mb-3 faqbtn" *ngIf="ismyredirecttoFaqEnabled" (click)="redirectToFaq()">
          {{ 'btnreadfaq' | translate }}
          </button>
      </div>
    </div>
    <div class="row py-2 text-center manage-footer mx-3 ">
      <img  alt="footer-img" class="footer-img p-2" src="../../../assets/img/myalconhome-img.png">
      <div class="footer-card-titile">{{ 'myalconhome' | translate }}</div>
      <div class="hme-subtitle">{{ 'msgvisithome' | translate }}</div>
      <div class="py-3">        
        <button 
          type="button"
          class="btn btn-lg btn-sm fw-bold oval-logout-button rounded-5 visitbtn" *ngIf="ismyredirecttoHomeEnabled"  (click)="redirectToHome()"
        >
          {{ 'btnvisitmyalconhome' | translate }}
        </button>
      
      </div>
    </div>
  
  </div>
</ng-container>
